import type { TelemetryQuery } from './api-client.js';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: (shopId: string) => ['dashboard', shopId, 'stats'] as const,
};

export const machineKeys = {
  all: ['machines'] as const,
  list: (shopId: string) => ['machines', shopId, 'list'] as const,
  detail: (shopId: string, machineId: string) =>
    ['machines', shopId, 'detail', machineId] as const,
  telemetry: (shopId: string, machineId: string, params: TelemetryQuery = {}) =>
    [
      'machines',
      shopId,
      'detail',
      machineId,
      'telemetry',
      { from: params.from ?? null, to: params.to ?? null, limit: params.limit ?? null },
    ] as const,
  alarms: (shopId: string, machineId: string) =>
    ['machines', shopId, 'detail', machineId, 'alarms'] as const,
};

export const toolKeys = {
  all: ['tools'] as const,
  list: (shopId: string, machineId: string) =>
    ['tools', shopId, machineId, 'list'] as const,
  library: (shopId: string) => ['tools', shopId, 'library'] as const,
  assignments: (shopId: string, toolId: string) =>
    ['tools', shopId, 'library', toolId, 'assignments'] as const,
  graveyard: (shopId: string) => ['tools', shopId, 'graveyard'] as const,
};

export const custodyKeys = {
  holders:     (shopId: string) => ['custody', shopId, 'holders'] as const,
  outstanding: (shopId: string) => ['custody', shopId, 'outstanding'] as const,
  pocketRules: (shopId: string, machineId: string) =>
    ['custody', shopId, machineId, 'pocketrules'] as const,
};

export const teamKeys = {
  me:          (shopId: string) => ['team', shopId, 'me'] as const,
  users:       (shopId: string) => ['team', shopId, 'users'] as const,
  invite:      (shopId: string, inviteId: string) => ['team', shopId, 'invite', inviteId] as const,
  assignments: (shopId: string, machineId: string) =>
    ['team', shopId, 'assignments', machineId] as const,
};

export type DashboardKey = ReturnType<typeof dashboardKeys.stats>;
export type MachineListKey = ReturnType<typeof machineKeys.list>;
export type MachineDetailKey = ReturnType<typeof machineKeys.detail>;
export type MachineTelemetryKey = ReturnType<typeof machineKeys.telemetry>;
export type MachineAlarmsKey = ReturnType<typeof machineKeys.alarms>;
export type ToolListKey = ReturnType<typeof toolKeys.list>;
export type ToolLibraryKey = ReturnType<typeof toolKeys.library>;
